export default __webpack_public_path__ + "static/media/css-r-bg (1).2c08f7c9.png";